/**
 * DATA LAYER: SOCCER (FOOTBALL) OVERLAY
 * Se encarga de la comunicación HTTP con la API de Fútbol/Soccer.
 */

export const GetSoccerConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}soccer/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetSoccerConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}soccer/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ShowSoccerOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}soccer/show`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HideSoccerOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}soccer/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};
